import { Controller } from "@hotwired/stimulus";
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';

export default class extends Controller {
    static targets = ["swiper", "prev", "next"]

    initialize() {
        const swiper = new Swiper(this.swiperTarget, {
            modules: [Navigation],
            slidesPerView: 1,
            spaceBetween: 20,
            breakpoints: {
                640: {
                  slidesPerView: 2,
                },
                768: {
                  slidesPerView: 3,
                },
                1024: {
                    slidesPerView: 4,
                }
            },
            navigation: {
                nextEl: this.nextTarget,
                prevEl: this.prevTarget,
            },
            loop: true
        });
        
        this.prevTarget.classList.add("swiper-button-disabled");
        swiper.on('slideChangeTransitionEnd', function () {
            this.prevTarget.classList.remove("pointer-events-none");
        }.bind(this));
    }
}